
import { cn } from "@/lib/utils";

interface CertificateBackgroundProps {
  style: {
    gradient: string;
    pattern: string;
  };
}

export function CertificateBackground({ style }: CertificateBackgroundProps) {
  return (
    <>
      <div className={cn(
        "absolute inset-2 sm:inset-3 border-2 border-transparent",
        `bg-gradient-to-r ${style.gradient}`,
        "[border-image:linear-gradient(to_right,var(--tw-gradient-from),var(--tw-gradient-via),var(--tw-gradient-to))_1]",
        "animate-fade-in transition-all duration-500"
      )} />
      
      <div className={cn(
        "absolute inset-0 opacity-5",
        `${style.pattern}`,
        "bg-[linear-gradient(45deg,currentColor 25%,transparent 25%,transparent 75%,currentColor 75%,currentColor),linear-gradient(45deg,currentColor 25%,transparent 25%,transparent 75%,currentColor 75%,currentColor)]",
        "bg-[length:30px_30px] sm:bg-[length:60px_60px]",
        "[background-position:0_0,15px_15px] sm:[background-position:0_0,30px_30px]"
      )} />
    </>
  );
}
